import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColor from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      cartao: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: theme.spacing(2, 1.5, 1),
        [theme.breakpoints.down('xs')]: {
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: theme.spacing(1.5),
        },
      },
      label: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 16,
        color: sicrediColor.secondarySicrediDarker,
      },
      value: {
        fontFamily: '"Exo 2", sans-serif',
        fontWeight: 300,
        fontSize: 20,
        color: sicrediColor.secondarySicrediDark,
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('xs')]: {
          marginBottom: 'auto',
          marginRight: theme.spacing(1.5),
        },
      },
      asButton: {
        padding: 0,
        '& > .MuiCardActionArea-root': {
          padding: theme.spacing(2, 1.5, 1),
          [theme.breakpoints.down('xs')]: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            padding: theme.spacing(1.5),
          }
        },
        '& $label': {
          color: sicrediColor.primarySicredi,
        },
      },
    }),
  { name: 'LabelValue' }
);
